var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTabCam = function SvgTabCam(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4",
    width: 32,
    height: 32,
    fill: "#000",
    viewBox: "0 0 16 16",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path2",
    fill: "currentColor",
    d: "M11.82 3.646a.6.6 0 0 0-.219.05L4.454 7.089a.59.59 0 0 0-.254.741L5.42 10.4a.55.55 0 0 0 .515.317c.076 0 .151-.015.24-.05l3.507-1.664c.15.293.457.494.797.494a.894.894 0 0 0 .904-.904 1 1 0 0 0-.071-.367l2.01-.952a.59.59 0 0 0 .255-.74l-1.228-2.59a.6.6 0 0 0-.529-.297M2.76 8.05a.41.41 0 0 0-.346.19.35.35 0 0 0-.02.34l1.382 2.892c.06.12.181.19.318.19a.4.4 0 0 0 .317-.162l.607-.889-.014-.028-1.178-2.498zm7.494 1.877v1.15c0 .373.304.677.677.677h2.71v-.451h-2.71a.226.226 0 0 1-.226-.226v-1.15a1.4 1.4 0 0 1-.226.021q-.114 0-.225-.021"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path5653",
    fill: "currentColor",
    d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTabCam);
export default ForwardRef;